// Dynamic table layout. Groups are fetched from backend and cached in memory
// + localStorage. Components import getSections() / tableLabel(n) which read
// the current cache. Call `setTableGroups(newGroups)` after fetching/editing.

const DEFAULT_GROUPS = [
    { label: "Cam", count: 4 },
    { label: "Orta", count: 4 },
    { label: "Duvar", count: 3 },
    { label: "Dış Sağ", count: 4 },
    { label: "Dış Sol", count: 5 },
    { label: "Mescit", count: 3 },
];

const STORAGE_KEY = "tables_groups";

function readCache() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (Array.isArray(parsed) && parsed.every((g) => g && g.label && g.count > 0)) {
                return parsed;
            }
        }
    } catch {
        /* ignore */
    }
    return DEFAULT_GROUPS;
}

let _groups = readCache();

export function getGroups() {
    return _groups;
}

export function setTableGroups(newGroups) {
    if (!Array.isArray(newGroups) || newGroups.length === 0) return;
    _groups = newGroups.map((g) => ({ label: String(g.label), count: Number(g.count) }));
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(_groups));
    } catch {
        /* ignore */
    }
    window.dispatchEvent(new Event("tables-updated"));
}

// Build display sections. Currently a single "Masalar" section that contains
// all groups; the WaiterDashboard renders sub-group headers.
export function getSections() {
    let cursor = 1;
    const groups = _groups.map((g) => {
        const from = cursor;
        const to = cursor + g.count - 1;
        cursor = to + 1;
        return { label: g.label, from, to };
    });
    return [{ label: "Masalar", groups }];
}

export function tableLabel(n) {
    let cursor = 1;
    for (const g of _groups) {
        const from = cursor;
        const to = cursor + g.count - 1;
        if (n >= from && n <= to) {
            return `${g.label} ${n - from + 1}`;
        }
        cursor = to + 1;
    }
    return `Masa ${n}`;
}

// Named export kept for callers that used the old constant.
export const SECTIONS = getSections();
